import React, { ComponentProps } from 'react';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { RoleSettingsEditView } from './views/RoleSettingsEditView';
import { RoleSettingsDefaultView } from './views/RoleSettingsDefaultView';
import { useAppContext } from '../../contexts/AppContext/AppContext';

type RoleDefaultForPageTypeSettingsProps = Views<DefaultView<RoleSettingsDefaultView> & EditView<RoleSettingsEditView>>;
function RoleDefaultForPageTypeSettings(props: RoleDefaultForPageTypeSettingsProps) {
  const { active } = useAppContext().editModeInfo;
  return active
    ? <RoleSettingsEditView {...props.views.edit} />
    : <RoleSettingsDefaultView {...props.views.default} />;
}

export const RoleDefaultForPageTypeSettingsBlock = asBlock(
  RoleDefaultForPageTypeSettings,
  BlockType.roledefaultforpagetypesettings,
);
export type RoleDefaultForPageTypeSettingsBlock = ComponentProps<typeof RoleDefaultForPageTypeSettingsBlock>;
